import { isTouchScreen } from '../../../styles'
import type { Tokens } from '../../../theming/types'
import type { ToastMessageProps } from '..'

export default (config: {
  props: Pick<ToastMessageProps, 'closeButton' | 'kind'>
  tokens: Tokens
}) => {
  const { props, tokens } = config
  const { kind = 'information' } = props

  const kindStyles = {
    danger: {
      icon: {
        color: tokens.dark.iconColorError,
      },
    },
    information: {
      icon: {
        color: tokens.iconColorInverse,
      },
    },
    loading: {
      icon: undefined,
    },
    success: {
      icon: {
        color: tokens.dark.iconColorSuccess,
      },
    },
    warning: {
      icon: {
        color: tokens.dark.iconColorWarning,
      },
    },
  }

  return {
    default: {
      outerWrap: {
        // This only works when its not on the same container that contains the background-color.
        backdropFilter: 'blur(8px)',
        borderRadius: tokens.radiusSizeS,
      },

      wrap: {
        alignItems: 'flex-start',
        backgroundColor: tokens.bgColorGlassTint,
        backgroundClip: 'padding-box',
        border: `${tokens.borderWidthS} solid ${tokens.borderColorSubtleInverse}`,
        borderRadius: tokens.radiusSizeS,
        // TODO: Replace with glass high token when available.
        boxShadow: '0 8px 32px 0 rgba(30, 24, 30, 0.3)',
        color: tokens.fontColorInverse,
        display: 'flex',
        maxWidth: '440px',
        minWidth: '144px',
        paddingBlock: tokens.spacingGap150,
        paddingInlineEnd: props.closeButton
          ? tokens.spacingGap150
          : tokens.spacingGap250,
        paddingInlineStart: tokens.spacingGap200,
        width: 'auto',
      },

      content: {
        ...tokens.fontBodyS,
        marginBlockEnd: '6px',
        marginBlockStart: '6px',

        ...(props.closeButton && {
          [isTouchScreen]: {
            marginBlockStart: '14px',
          },
        }),
      },

      action: {
        marginBlockStart: tokens.spacingGap150,
        marginBlockEnd: tokens.spacingGap50,
      },

      icon: {
        ...kindStyles[kind].icon,
        height: '32px',

        ...(props.closeButton && {
          [isTouchScreen]: {
            marginBlockStart: tokens.spacingGap150,
            height: '24px',
          },
        }),
      },

      startElement: {
        marginInlineEnd: tokens.spacingGap100,
      },

      closeButton: {
        marginInlineStart: tokens.spacingGap100,
      },
    },

    loading: {
      spinner: {
        height: '32px',
        width: '24px',

        ...(props.closeButton && {
          [isTouchScreen]: {
            marginBlockStart: tokens.spacingGap150,
            height: '24px',
          },
        }),
      },
    },

    motionVariants: {
      toastWrap: {
        initial: {
          opacity: 0,
        },

        enter: (toastHeight: number) => ({
          y: [toastHeight, 0],
          opacity: 1,
          transition: {
            duration: 0.25,
          },
        }),

        exit: {
          opacity: 0,
          transition: {
            when: 'beforeChildren',
            duration: 0.25,
            ease: 'harmonize',
          },
        },
      },

      toastInner: {
        exit: (toastHeight: number) => ({
          height: [toastHeight, 0],
          padding: [24, 0],
          margin: [16, 0],
          transition: {
            duration: 0.25,
          },
        }),
      },
    },
  } as const
}
